/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Bulk_Delete_BodyInputs */

const en_recipes_bulk_delete_body = /** @type {(inputs: Recipes_Bulk_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They will be removed from your household's recipes.`)
};

const de_recipes_bulk_delete_body = /** @type {(inputs: Recipes_Bulk_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie werden aus den Rezepten deines Haushalts entfernt.`)
};

/**
* | output |
* | --- |
* | "They will be removed from your household's recipes." |
*
* @param {Recipes_Bulk_Delete_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_bulk_delete_body = /** @type {((inputs?: Recipes_Bulk_Delete_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Bulk_Delete_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_bulk_delete_body(inputs)
	return en_recipes_bulk_delete_body(inputs)
});